import React from "react";
//Limitless imports
import { useExpertProfileContext, ExpertTaskFilters } from "@limitless/expert";
import ModernTaskListFiltersHeader from "./ModernTaskListFiltersHeader";
import MuiInputBase from "@mui/material/InputBase";
//Modern imports
import Grid from "@limitless/modern/layout/Grid";
import Paper from "@limitless/modern/surfaces/paper/Paper";
import Button from "@limitless/modern/inputs/button/Button";
import Typography from "@limitless/modern/data-display/typography/Typography";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
// Limitless Icons
import Info from "@limitless/icons/InfoCircle";
import ModernTaskFiltersCheckbox from "./ModernTaskFiltersCheckbox";
import ModernTaskListTenantSelection from "./ModernTaskListTenantSelection";
import ModernTaskTypeInfo from "./ModernTaskTypeInfo";

const ModernTaskListFilters = () => {
    const {
        profile: { balanceCurrencySymbol, expertTrustedLocationType }
    } = useExpertProfileContext();
    const [showTaskTypeInfo, setShowTaskTypeInfo] = React.useState(false);

    const isSecureAccess = ["platform", "tenant"].includes(expertTrustedLocationType);

    const renderTaskTypeFilters = (filterSet, onChange, isQualityReviewGroupFound) => {
        let filtersSet = filterSet;
        if (Object.keys(isQualityReviewGroupFound).length > 0) {
            filtersSet = { ...filtersSet, reviewDetailed: { ...filtersSet.reviewDetailed, visible: true } };
        }

        return Object.keys(filtersSet).map((filterKey, index) => {
            const filter = filtersSet[filterKey];

            return (
                filter.visible && (
                    <React.Fragment key={index}>
                        <ModernTaskFiltersCheckbox
                            label={filter.label}
                            onChange={() => onChange(filterKey, filter.value, !filter.value)}
                            checked={filter.value}
                            labelVariant="body2"
                            sx={{ paddingLeft: "2px", paddingBottom: "5px", paddingTop: "5px" }}
                            taskType={filterKey}
                        />
                    </React.Fragment>
                )
            );
        });
    };
    return (
        <Paper
            sx={{
                borderRadius: "10px",
                paddingTop: 2,
                paddingLeft: 2,
                paddingBottom: 2,
                height: "auto",
                maxHeight: "calc(100vh - 100px)",
                overflowY: "auto",
                boxShadow: "0px 2px 8px -2px rgba(0, 0, 0, 0.08)"
            }}
        >
            <ExpertTaskFilters>
                {({
                    filters,
                    onGroupChange,
                    onTaskTypeFilterChange,
                    onClearFilters,
                    onApplyFilters,
                    onFeeFilterChange,
                    fieldErrors,
                    isFormInvalid,
                    removeSelectedFilter,
                    groupByTenantName,
                    isQualityReviewGroupFound
                }) => {
                    const checkedFilters = filters.checkedFilters.length > 0;
                    const clearButton = filters.selectedFilters.length === 0;

                    return (
                        <>
                            <ModernTaskListFiltersHeader
                                id="clearFilterBtn"
                                disabled={clearButton}
                                onClick={onClearFilters}
                            />
                            <Grid>
                                <Grid
                                    sx={{
                                        height: "auto",
                                        maxHeight: "calc(100vh - 235px)",
                                        overflowY: "auto",
                                        scrollbarWidth: "none",
                                        paddingRight: 2
                                    }}
                                >
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        sx={{ marginTop: 1, paddingBottom: 0 }}
                                    >
                                        <Grid
                                            mb={1}
                                            display="flex"
                                            flexDirection="row"
                                            width="100%"
                                            justifyContent="space-between"
                                        >
                                            <Typography variant={"body2"}>{"Task Type"}</Typography>
                                            <IconButton
                                                icon={<Info />}
                                                onClick={() => setShowTaskTypeInfo(!showTaskTypeInfo)}
                                                id="taskTypeInfoButton"
                                            />
                                        </Grid>

                                        <Grid container direction={"column"}>
                                            {renderTaskTypeFilters(
                                                filters.taskType,
                                                onTaskTypeFilterChange,
                                                isQualityReviewGroupFound
                                            )}
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        container
                                        sx={{ display: "flex", flexDirection: "row", marginTop: 2, paddingBottom: 0 }}
                                    >
                                        <Typography mr={1} variant={"body2"}>
                                            Reward Fee
                                        </Typography>
                                    </Grid>
                                    <Grid container direction="row" gap={2}>
                                        <Grid width={"95px"}>
                                            <MuiInputBase
                                                name="min"
                                                label={""}
                                                placeholder={balanceCurrencySymbol && `${balanceCurrencySymbol} Min`}
                                                id="minFeeInputField"
                                                sx={{ width: "95px", height: "42px", marginTop: "8px" }}
                                                onChange={e => onFeeFilterChange("minFee", Math.abs(e.target.value))}
                                                type="number"
                                                value={filters.taskFee.minFee}
                                                onKeyDown={evt => evt.key === "e" && evt.preventDefault()}
                                            />
                                        </Grid>
                                        <Grid width={"95px"}>
                                            <MuiInputBase
                                                name="max"
                                                label=""
                                                placeholder={balanceCurrencySymbol && `${balanceCurrencySymbol} Max`}
                                                InputLabelProps={{ shrink: true }}
                                                id="maxFeeInputField"
                                                sx={{ width: "95px", height: "42px", marginTop: "8px" }}
                                                onChange={e => onFeeFilterChange("maxFee", Math.abs(e.target.value))}
                                                type="number"
                                                value={filters.taskFee.maxFee}
                                                onKeyDown={evt => evt.key === "e" && evt.preventDefault()}
                                            />
                                        </Grid>
                                    </Grid>
                                    {fieldErrors.text && (
                                        <Typography color="error" variant="caption">
                                            {fieldErrors.text}
                                        </Typography>
                                    )}
                                    {/* </Paper> */}
                                    <ModernTaskListTenantSelection
                                        filters={filters}
                                        groupByTenantName={groupByTenantName}
                                        onGroupChange={onGroupChange}
                                        isSecureAccess={isSecureAccess}
                                    />
                                </Grid>
                                <Grid paddingRight={2} paddingTop={2}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        id="applyFilterBtn"
                                        disabled={!checkedFilters || isFormInvalid}
                                        onClick={onApplyFilters}
                                    >
                                        {"Apply"}
                                    </Button>
                                </Grid>
                            </Grid>

                            {showTaskTypeInfo && (
                                <ModernTaskTypeInfo
                                    filterSet={filters.taskType}
                                    isQualityReviewGroupFound={isQualityReviewGroupFound}
                                    onClose={() => {
                                        setShowTaskTypeInfo(false);
                                    }}
                                />
                            )}
                        </>
                    );
                }}
            </ExpertTaskFilters>
        </Paper>
    );
};

export default ModernTaskListFilters;
